import { render, staticRenderFns } from "./bidClarification.vue?vue&type=template&id=5fa25394&scoped=true"
import script from "./bidClarification.vue?vue&type=script&lang=js"
export * from "./bidClarification.vue?vue&type=script&lang=js"
import style0 from "./bidClarification.vue?vue&type=style&index=0&id=5fa25394&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa25394",
  null
  
)

export default component.exports